<div class="input-group" [class]="classDate" style="position: relative;">
    <input type="text" [(ngModel)]="selectedDate" (ngModelChange)="selectedDateChanged($event)" class="form-control" (click)="togglePicker = !togglePicker">
    <button *ngIf="hasIcon" class="input-group-text" type="button" (click)="togglePicker = !togglePicker">
      <i class="feather icon-calendar icon-md text-muted"></i>
    </button>

    <div class="w-100 d-flex justify-content-end">
        <div class="yearMonth-picker" [ngClass]="{'d-none': !togglePicker,'d-block':togglePicker}">
            <div class="year-picker d-flex align-items-center justify-content-center">
                <div class="row my-2">
                    <div class="col-12">
                        <div class="prev-year" [hidden]="selectedYear <= minValue.getFullYear()" (click)="decrementYear()"><i class="mdi" [ngClass]="{' mdi-chevron-left': liveTranslate.currentLang != 'ar',' mdi-chevron-right':liveTranslate.currentLang=='ar'}"></i></div>
                        <div class="shown-year"><span class="">{{selectedYear}}</span></div>
                        <div class="next-year" [hidden]="selectedYear >= maxValue.getFullYear()" (click)="incrementYear()"><i class="mdi" [ngClass]="{' mdi-chevron-right': liveTranslate.currentLang != 'ar',' mdi-chevron-left':liveTranslate.currentLang=='ar'}"></i></div>
                    </div>
                </div>
            </div>
            <div class="month-picker d-flex align-items-center justify-content-center">
                <div class="row">
                    <div class="col-4" *ngFor="let m of months">
                        <div class="month"> 
                            <div (click)="selectMonth(m.id)" [ngClass]="{'active': selectedMonth == m.id,'is-disabled': (m.id < minValue.getMonth())}">{{m.subName | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>